import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { BackButton, ClearFilterButton, CreateButton, EditButton, ExportButton, FilterButton, ImportButton } from '../../../../Components/Utils/Buttons';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';



const FireSuppressionLayout =({
    getData = () => {},
    setSearchQuery = () => {},
    CreateAccess = false,
    ImportAccess = false,
    setOpen = () => {},
    setOpenExport = () => {},
    children,
    onCreateClick,
    searchValue = "",
    searchFun = () => {},
    isFilter = false,
    setFilterOpen = () => {},
    newfilter = false,
    ClearFilter = () => {},
    neededSearch = false,
    showproject = true,
    isCard = true,
    setViewMode = () => {},
    viewMode = "",
    ExportAccess = false,
    BackButtonAccess=false,
    EditBttonAccess=false,
  }) => {
    let { pathname } = useLocation();
    const [module, setModule] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
    const { fireSuppressionViewId } = useParams();
    const data = location.state?.data;
  
    const [screenSize, setScreenSize] = useState({
      width: window.innerWidth,
    });
  
    useEffect(() => {
      const handleResize = () => {
        setScreenSize({
          width: window.innerWidth,
        });
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    useEffect(() => {
       if (pathname == `/collectionAndreturn/fireSuppression/view/${fireSuppressionViewId}`) {
         setModule("Details");
       } 
      //  else if (pathname == `/collectionAndreturn/fireSuppression/form/${fireSuppressionViewId}`) {
      //    setModule("Form");
      //  }
       else if (pathname == `/collectionAndreturn/fireSuppression/equipment/${fireSuppressionViewId}`) {
        setModule("Equipments");
      }
       
     }, [pathname]);
   
     let LinkItem = [
       {
         label: "Details",
         link: `/collectionAndreturn/fireSuppression/view/${fireSuppressionViewId}`,
         access: GetAccess(),
       },
      //  {
      //    label: "Form",
   
      //    link: `/collectionAndreturn/fireSuppression/form/${fireSuppressionViewId}`,
      //    access: GetAccess(),
      //  },
       {
        label: "Equipments",
  
        link: `/collectionAndreturn/fireSuppression/equipment/${fireSuppressionViewId}`,
        access: GetAccess(),
      },
     ];
   
  
    return (
      <div className=" w-full  h-full py-2 px-1 md:overflow-hidden">
        <div className="md:flex justify-between w-full ">
        <div className="md:flex justify-between w-full ml-6">
        <Breadcrumb
          items={[
 
            
            {
              name: "Fire Suppression",
              link:"/collectionAndreturn/fireSuppression"
             
            },

            { name: module },
          ]}
        />
        <div className=" flex justify-end gap-2 mr-9 md:mr-0">
                    <Link
                      to={`/collectionAndreturn/fireSuppression`}
                      state={{
                        currentPage: pageIndex,
                        searchQuery: searchQuery != "" ? searchQuery : "",
                      }}
                    >
                        
                      <BackButton link={true} />
                    </Link>
                
               {/* {EditBttonAccess&&(   
                  <Link
                      to={`/collectionAndreturn/fireSuppression/edit/${fireSuppressionViewId}`}
                      state={{
                        data: data,
                        from: `/collectionAndreturn/fireSuppression/view/${fireSuppressionViewId}`,
                      }}
                    >
                      <EditButton height="8" />
                    </Link>
               )} */}
                  </div>
        </div>
          
  
    
        
        </div>
        <div className=" w-full  flex items-center gap-x-1 ml-4 ">
            {LinkItem &&
              LinkItem.map((item, i) => {
                const isActive = item?.link === pathname;
                return (
                  <>
                    {item.access && (
                      <Link
                   
                                       to={item?.link}
                                       key={item?.link}
                                       className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                         ${isActive 
                                           ? "bg-baseColor-primary text-white" 
                                           : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                         }`}
                                     >
                                       {item?.label || ""}
                      </Link>
                    )}
                  </>
                );
              })}
          </div>
        <div className=" w-full h-[calc(100vh-165px)]  ">{children}</div>
      </div>
    );
  };
  

export default FireSuppressionLayout